<template>
  
    <div class="">
  
          <div class="myCenter">  
  
              <h2 class=" text-red-700 myClassTitle w-64 font-extrabold">
              {{membership.name}}
              </h2>
  
          </div>

          <div class="myCenter">  
  
              <h2 class=" text-red-700 myClassTitle font-extrabold w-64">
              {{membership.name}}

              </h2>
          </div>
  
          <div class="w-full flex flex-col lg:flex-row items-center justify-around h-full pb-3 text-sm lg:text-lg text-grey-dark pt-2 lg:mr-24">
  
              <div class="flex sm:flex-row mt-2">
  
  
                  <div class="myOverlayText myFullCenter w-64">   
  
                      <span class="font-bold mr-1 lg:mr-4">{{$t('memberships.period')}}</span>
  
                      <h2 class=" text-red-700">
                      {{membershipPeriod()}}
                      </h2>
                  </div>
                    
                  <div v-if="membership.pay_cash" class="myOverlayText myFullCenter">
                      
                      <span  class="font-bold">{{$t('classes.cash')}} </span>
  
                      <h2 class="text-pink-700">{{membership.cash_price}}</h2>
                  </div>

              </div> 
  
              <div class="flex lg:flex-col flex-row mt-2 me-2 lg:me-0">
  
                  <div class="flex flex-row pb-1 lg:pb-3 text-grey-dark">
                      
                      
                  <div class="myFullOverlayText myFullCenter">
                      <h3 class="text-black text-sm font-extrabold font-sans" >
                      <p class="text-pink-800">{{$t('memberships.facility/s')}}</p>
                      <p class="text-sm lg:text-lg border-pink-800 border-2 lg:border-4 rounded-full"></p>{{facility}}</h3>
                  </div>
  
                  <div v-if="membership.pay_points" class="myOverlayText myFullCenter">
                      
                      <span class="font-bold">{{$t('classes.points')}} </span>
  
                      <h2 class="text-pink-700">{{membership.price}}</h2>
                  </div>
                  </div>
              </div>
  
              <div class="flex text-center w-full">
  
                  <div class="myRowCenter"> 
  
                      <div class="myMixedOverlayText myFullCenter">
                              
                          <h4 v-if="membership.males && membership.females" class="font-bold lg:font-extrabold font-sans text-white">
                          <p>{{$t('sessions.mixed')}}</p></h4>
  
                          <h4 v-else  class="font-bold lg:font-extrabold font-sans text-white lg:rounded">
                          <p class="w-24 text-xs">{{$t('sessions.notMixed')}}</p></h4>
                      </div> 
  
                      <div v-if="membership.business.is_private == true" class="myPrivateOverlayText myFullCenter">
                              
                          <h4  
                          class=" font-bold lg:font-extrabold font-sans text-white">
                          <p >{{$t('sessions.private')}}</p></h4>
                      </div>
                  </div>                                  
              </div>

          </div>
      </div>        
  </template>
  
  
  <script>
  
  import { RingLoader } from 'vue-spinners-css';
  
  import moment from 'moment';
  
  import myUpdates from '../../hasura/myUpdates';
  
  import componentsHelpers from '../../classes/componentHelpers';
  
  import cardImagesComponent from '../../components-v2/cards-components/CardImages';
    
  import { createPopper } from '@popperjs/core';
  
  export default {
  
      created(){
    
          // this.setType();
          this.setFacility();
      },
  
      mounted(){
            
          const dayDate = this.dayDate;
      },
  
      props: {

          disablePage: false,
  
          disableButton: false,
  
          isOnline: false,
    
          dayDate: '',
  
          membership:{
  
              type: Object
          },
  
          businessInfo:{
        
              type: Object,
          },
  
          instructors:{
  
              type: Array 
          },
  
          myReload: {
  
              type: Function
          },
  
          index: 0,

  
          openMembershipMapModal: {
  
              type: Function
          },
      },
  
      components:{
  
          RingLoader,
          cardImagesComponent,      },
  
      methods:{
  
          membershipPeriod(){
  
              let period = '';            
  
              if(this.membership.in_years > 0){
                  
                  if(period != ''){
  
                      period = period + ', '
                  }
  
                  if(this.membership.in_years == 1){
  
                      period = period + `${this.membership.in_years} year`
  
                  }else{
  
                      period = period + `${this.membership.in_years} years`
                  }
              } 
              if(this.membership.in_months > 0){
                  
                  if(period != ''){
  
                      period = period + ', '
                  }
  
                  if(this.membership.in_months == 1){
  
                      period = period + `${this.membership.in_months} month`
  
                  }else{
  
                      period = period + `${this.membership.in_months} months`
                  }
              } 
              if(this.membership.in_days > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.membership.in_days == 1){
  
                      period = period + `${this.membership.in_days} day`;
  
                  }else{
  
                      period = period + `${this.membership.in_days} days`;
                  }
              } 
              if(this.membership.free_years > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.membership.free_years == 1){
  
                      period = period + `${this.membership.free_years} free year`;
  
                  }else{
  
                      period = period + `${this.membership.free_years} free years`;
                  }
              } 
              if(this.membership.free_months > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.membership.free_months == 1){
  
                      period = period + `+ ${this.membership.free_months} free month`;
  
                  }else{
  
                      period = period + `${this.membership.free_months} free months`;
                  }
              } 
              if(this.membership.free_days > 0){
                  
                  if(period != ''){
  
                      period = period + ', ';
                  }
  
                  if(this.membership.free_days == 1){
  
                      period = period + `+ ${this.membership.free_days} free day`;
  
                  }else{
  
                      period = period + `+ ${this.membership.free_days} free days`;
                  }
              }
  
              return period;
          },

  
          toastIt(){
  
              const subOptions =  { 	 theme: "toasted-primary", position: "bottom-center", duration : 5000,
               keepOnHover: true, singleton:true };
              this.$toasted.clear();
              this.$toasted.info(this.membership.class.description, subOptions);
          },
  
          showDescription(){
  
  
          },
  
          closePop(){
  
              this.popoverShow = false;
          },
  
          setFacility(){
              
              const facilities = this.membership.three_gym_membership_facilities;
  
              for(let i = 0; i < facilities.length; i++){
  
                  if(i != facilities.length - 1){
                      
                      this.facility = this.facility + facilities[i].facility.name + ', '
                  }
                  else {
                    
                    this.facility = this.facility + facilities[i].facility.name;
                  }
              }
              // console.log(`type is ${this.type}`);
              return this.facility;
          },
      },
  
    data: function(){
  
      return{
  
          loading:false,
          myDayDate: this.dayDate,
          startTime: moment(new Date(`1970/01/01 ${this.membership.start_time}`)).format('hh:mm A'),
          endTime: moment(new Date(`1970/01/01 ${this.membership.end_time}`)).format('hh:mm A'),
          instructorName: '',
          filteredSlots: [],
          weekDays: '',
          edit: false,
          initiated: false, 
          popoverShow:false,
          type: '',   
          facility:'',  
  
          points: 0,
          capacity: 0,
  
          days: [7],
          myEndDate: ''
  
  
      }
    },
  
  }
  </script>
  
  <style>
  
  </style>
  